import React from "react";
import { productores } from "~constants/productores";
import ColorLabel from "../colorLabel/ColorLabel";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: { paddingLeft: "10px" },
}));

interface ColorLabelProductorProps {
  productor?: string | null;
}

const ColorLabelProductor: React.FC<ColorLabelProductorProps> = ({
  productor,
}) => {
  const classes = useStyles();

  const productorIsValid = () => {
    return !!productor && productor in productores;
  };

  return (
    <span className={classes.container}>
      {productorIsValid() ? (
        <ColorLabel
          variant={"success"}
          text={(productores as Record<string, string>)[productor as string]}
        />
      ) : (
        <ColorLabel text={"Indeterminado"} />
      )}
    </span>
  );
};

export default ColorLabelProductor;
